import ProductsDetailsContainer from './ProductDetails.container';
export default ProductsDetailsContainer;